import React from 'react';
import { FaMoon, FaSun } from 'react-icons/fa';
import { useAdminTheme } from '../context/AdminThemeContext';

const AdminThemeToggle = ({ className = '' }) => {
  const { theme, toggleTheme } = useAdminTheme();

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label="Toggle theme"
      className={`rounded-2xl border border-primary/25 bg-white/90 p-2.5 text-slate-600 shadow-sm transition-all hover:border-primary hover:text-black dark:border-white/15 dark:bg-white/5 dark:text-gray-200 dark:hover:border-primary dark:hover:text-primary ${className}`}
    >
      {theme === 'dark' ? <FaSun size={15} /> : <FaMoon size={15} />}
    </button>
  );
};

export default AdminThemeToggle;
